import React from "react";
import { stepFiveData } from "./stepData";
import { Typography } from "@mui/material";

const StepFive = () => {
  return (
    <>
      <div>
        <div className=" pt-3 d-flex flex-column gap-3">
          <Typography
            sx={{
              fontSize: "23.8532px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepFiveData[0].heading}
          </Typography>

          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "24px",
              letterSpacing: "0.08px",
              fontWeight: 500,
              fontFamily: "'Archivo',sans-serif",
            }}
          >
            While <strong>Interest Rate</strong> is a key factor, the{" "}
            <strong>Annual Percentage Rate (APR)</strong> offers a more
            comprehensive picture of your loan’s cost. The APR accounts for the
            interest rate as well as additional fees, such as processing fees
            and any prepayment charges. This helps you make better comparisons
            between loan offers.
          </Typography>
        </div>

        <div className="tips mt-4 ">
          <div id="border_line"></div>
          <div id="tip__container" className="px-4 py-4">
            <div className="px-3 py-2">
              <div className="d-flex gap-2 align-items-center">
                <img src='/Assets/Images/tongue-out.webp' alt="" style={{ width: 30, height: 30 }} />
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#59266D",
                    // color: "yellow",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  MinEmi Tip:
                </Typography>
              </div>
              <div className="mt-2">
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#1F1F1F",
                    // color: "#f8f8f8",

                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  {stepFiveData[0].tip}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepFive;
